module.exports = __webpack_public_path__ + "static/media/icon.55bee76e.svg";